import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React from 'react';
import { cx } from '@paypalcorp/pp-react-utils';
import * as styles from './styles.css';
export { styles as elevationStyles };

var _excluded = ["level", "className", "children", "isFilter"];
var Elevation = function (_ref) {
  var level = _ref.level,
    className = _ref.className,
    children = _ref.children,
    _ref$isFilter = _ref.isFilter,
    isFilter = _ref$isFilter === void 0 ? false : _ref$isFilter,
    rest = _objectWithoutProperties(_ref, _excluded);
  var levelStylesMap = {
    1: styles.level1,
    2: styles.level2,
    3: styles.level3
  };
  var filterStylesMap = {
    1: styles.filterLevel1,
    2: styles.filterLevel2,
    3: styles.filterLevel3
  };
  var classNames = cx(isFilter ? filterStylesMap[level] : levelStylesMap[level], className);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: classNames
  }, rest, {
    "data-ppui": "true"
  }), children);
};

export { Elevation };
